import userSetting from '../../../services/user-setting.service'

export default {
  async saveUserSetting({ dispatch, commit }, data) {
    return await userSetting.saveUserSetting(data)
      .then(response => {
        if (response.status || response.success) {
          // dispatch("alertSuccess", typeof response.message == 'object' ? response.message[0] : response.message, { root: true })
          return Promise.resolve(true);
        } else {
          dispatch("alertError", typeof response.message == 'object' ? response.message[0] : response.message, { root: true })
        }
      }).catch(error => {
        dispatch("alertError", error, { root: true });
        return Promise.reject(false);
      })
  },

  async getUserSetting({ dispatch, commit }, data) {
    return await userSetting.getUserSetting(data)
      .then(response => {
        if (response.status || response.success) {
          const listUserSetting = response.data
          commit("SET_LIST_USER_SETTING", listUserSetting)
          // dispatch("alertSuccess", typeof response.message == 'object' ? response.message[0]:response.message, { root: true })
          return Promise.resolve(response.data);
        } else {
          dispatch("alertError", typeof response.message == 'object' ? response.message[0] : response.message, { root: true })
        }
      }).catch(error => {
        dispatch("alertError", error, { root: true });
        return Promise.reject(false);
      })
  },
  async refreshUserSetting({dispatch, commit}, data) {
    commit('REFRESH_USER_SETTING', data);
    return  Promise.resolve(JSON.parse(JSON.stringify(data)));
  }
}